import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('reports/incomes/receivables/selectors', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('reports/incomes/receivables/metrics', { params, ...config }),
  table: (params = {}, config = {}) => axios.get('reports/incomes/receivables/table', { params, ...config }),
  detail: (params = {}, config = {}) => axios.get('reports/incomes/receivables/detail', { params, ...config }),
  excel: (params = {}, config = {}) => axios.get('reports/incomes/receivables/excel', {
    params,
    responseType: 'blob',
    ...config,
  }),
  pdf: (params = {}, config = {}) => axios.get('reports/incomes/receivables/pdf', {
    params,
    responseType: 'blob',
    ...config,
  }),
};
